import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-page" }

import { computed, onMounted } from 'vue';

import useContext from '@/composables/useContext';
import { setDefaultMeta } from '@/composables/useMeta';

import HeaderMarked from '@/components/HeaderMarked.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentPage',
  setup(__props) {

const { page } = useContext();

const name = computed(() => {
  return page.value?.fields?._name;
});

const hideTitle = computed(() => {
  return page.value?.fields?.HideTitle;
});

const contentPageClass = computed(() => {
  return hideTitle.value
    ? 'content-page__content--gray'
    : 'content-page__content';
});

const blocks = computed(() => {
  return page.value?.blocks;
});

onMounted(() => {
  setDefaultMeta();
});


return (_ctx: any,_cache: any) => {
  const _component_blocks_repeater = _resolveComponent("blocks-repeater")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(contentPageClass.value)
    }, [
      (!hideTitle.value)
        ? (_openBlock(), _createBlock(HeaderMarked, {
            key: 0,
            class: "content-page__title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(name.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (blocks.value)
        ? (_openBlock(), _createBlock(_component_blocks_repeater, {
            key: 1,
            blocks: blocks.value.Main
          }, null, 8, ["blocks"]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})